import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { useGetInvoiceByIdV2Query } from '../api';
import DateUtils from 'utils/dateUtils';

export const useGetInvoiceDataById = (invoiceId: string, refetchOnMountOrArgChange = true) => {
  const currentTeam = useAppSelector(selectCurrentTeam);

  const query = useGetInvoiceByIdV2Query(
    {
      invoiceId,
      teamId: currentTeam?.id,
      timezone: DateUtils.getTimezoneLongName()
    },
    {
      skip: !invoiceId || !currentTeam?.id,
      refetchOnMountOrArgChange // Configurable: true by default for fresh data, false for cached data
    }
  );

  return {
    invoiceData: query.data?.invoice,
    // Smart loading: only show spinner if no data AND actually loading
    isLoading: query.isLoading && !query.data,
    isSuccess: query.isSuccess,
    isFetching: query.isFetching,
    refetch: query.refetch
  };
};
